export const getTaskBreakdown =`
query TaskStatusBreakdown($userId: Int!) { 

  taskStatusBreakdown(userId: $userId) { 

    success 

    error 

    message 

    data { 

      label 

      value 

    } 

  } 

} `

export const taskDistributionQuery =`
query { 

  taskDistribution { 

    success 

    error 

    message 

    data { 

      salesperson 

      taskCount 

    } 

  } 

} `

export const performanceAnalytics = `
query { 

  performanceAnalytics { 

    success 

    error 

    message 

    data { 

      salesperson 

      completionRate 

      pendingCount 

      avgResponseTime 

    } 

  } 

} `

export const followUpAndOverdueTasksQuery=`
query followupAndOverdueTasks($id:Int) {
  followupAndOverdueTasks(userId:$id) {
    success
    error
    message
    data {
      taskId
      title
      status
      assignedTo
      deadlineDate
      createdAt
    }
  }
} `;